/**
 * External Dependencies
 */
import React from "react";
import classNames from "classnames";
import { get } from "lodash";

import { IconContext } from "react-icons";
import * as fa from "react-icons/fa";
import * as fi from "react-icons/fi";
import * as md from "react-icons/md";
import * as ri from "react-icons/ri";
import * as bs from "react-icons/bs";
import * as io from "react-icons/io";
import * as gr from "react-icons/gr";
import * as ti from "react-icons/ti";
import * as fa6 from "react-icons/fa6";
import * as ai from "react-icons/ai";

const icons = {
  ...fa,
  ...fi,
  ...md,
  ...ri,
  ...bs,
  ...io,
  ...gr,
  ...ti,
  ...fa6,
  ...ai,
};

/**
 * Internal Dependencies
 */

const Icon = ({
  className,
  style,
  width,
  marginRight,
  marginLeft,
  type = "fi",
  name = "cantfindme",
  ...rest
}) => {
  const IconComponent = get(icons, [name], null);
  return IconComponent ? (
    <IconContext.Provider
      value={{
        style: {
          verticalAlign: "middle",
          marginRight: marginRight,
          marginLeft: marginLeft,
          width,
          ...style,
        },
        className: classNames("icon", className),
      }}
    >
      <IconComponent {...rest} />
    </IconContext.Provider>
  ) : null;
};

export default Icon;
